/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserGroupDetails {
    getFixupPrototypeFunction() { return UserGroupDetails.fixupPrototype; }

    static newInstance(model: Partial<UserGroupDetails>): UserGroupDetails {
        let obj = Object.assign(new UserGroupDetails(), model);
        UserGroupDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserGroupDetails>): UserGroupDetails {
        if (!model) return null;
        return UserGroupDetails.newInstance(<UserGroupDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserGroupDetails) {
        if (!obj) return;

        models.UserGroupDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserGroupDetails): boolean {
        Object.setPrototypeOf(obj, UserGroupDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
    }

    /**
     * Name of the user who created this user group
     */
    created_by: string;

    /**
     * When the user group was created
     */
    created_at: Date;

    /**
     * Name of the user last updated this user group
     */
    updated_by: string;

    /**
     * When the user group was last updated
     */
    updated_at: Date;

    /**
     * Name of the user group
     */
    group_name: string;

    /**
     * ID of tenants within the CoreStack account
     */
    tenant_ids: Array<string>;

    /**
     * List of role IDs assigned to UserGroup
     */
    roles: Array<string>;

    /**
     * List of users IDs assigned to UserGroup
     */
    users: Array<string>;

}
